import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { UTILS } from "utils";
import AppCollapse from "components/ui/AppCollapse.jsx"
import AppInput from "components/ui/AppInput.jsx";
import AppButton from "components/ui/AppButton.jsx";
const BusinessInfo = ({
  defaultOpen = false,
  businessName = "",
  domainName = "",
  domainNamePlaceholder = "",
  onBusinessNameChange,
  onDomainNameChange,
}) => {
    const { t } = useTranslation();

    const orderPageLink = useMemo(() => {
      const userDetail = UTILS.getCurrentUser();
      const storefront = userDetail?.storeFrontURL || "";
      const domain = domainName || domainNamePlaceholder || userDetail?.temporaryDomainName || "";
      return `${storefront}${domain}`;
    }, [domainName, domainNamePlaceholder]);
    return(
        <div className="w-full mb-3">
            <AppCollapse
              defaultOpen={defaultOpen}
              title={t("Business Information")}
              subtitle={t("Key details about your store's identity.")}
            >
              <div className="flex w-full flex-col gap-5 pt-1">
                <AppInput
                  label={t("Business Name")}
                  type="text"
                  placeholder={t("Enter business name")}
                  value={businessName}
                  onInput={(e) => {
                    onBusinessNameChange?.(e.target.value);
                  }}
                />
                <AppInput
                  label={t("Domain")}
                  type="text"
                  placeholder={t("your-store.resthero.io")}
                  value={domainName}
                  onInput={(e) => {
                    onDomainNameChange?.(e.target.value.toLowerCase());
                  }}
                />
                <AppInput
                  label={t("Store Link")}
                  type="text"
                  disabled
                  value={orderPageLink}
                >
                  <AppButton
                    onClick={() => {
                      navigator.clipboard.writeText(orderPageLink);
                      UTILS.successNotification(t("Copied to Clipboard"));
                    }}
                  >
                    {t("Copy link")}
                  </AppButton>
                </AppInput>
              </div>
            </AppCollapse>
        </div>
        )
            
}
export default BusinessInfo